import css from '@styled-system/css';

const strikeThrough = ({ strikeThrough }) =>
  strikeThrough !== 'none' &&
  css({
    position: 'relative',
    display: 'inline-block',
    color: () => (strikeThrough === 'default' ? 'neutrals.4' : 'inherit'),
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      borderBottom: 1,
      borderColor: () =>
        strikeThrough === 'negative' ? 'negative.default' : 'neutrals.4',
      width: '100%',
    },
  });

export default strikeThrough;
